import { Flex, Typography } from "antd"
import classname from "classname"

import InfoTooltip from "../../../../../../Components/InfoTooltip/InfoTooltip"

import "./ProgramStatus.less"

const { Text } = Typography

const statusToVariantMap = {
  pending: "neutral",
  compliant: "success",
  warning: "warning",
  under_monitoring: "warning",
  no_status: "neutral"
}

const MonitoringProgramStatus = ({ status, styles }) => {
  return (
    <Flex className="monitoring-program-status" align="center" gap={4} style={styles}>
      <Text className={classname("status-text", statusToVariantMap[status?.status] || "neutral")}>
        {status?.status_label || "Unknown status"}
      </Text>
      <InfoTooltip title={status?.tooltip || "No information available"} />
    </Flex>
  )
}

export default MonitoringProgramStatus
